// Formerly ULTIPRO, now UKG PRO RAAS (MAIN & APPEND)
import {
  DataSourceSetupComposite,
  enumATSModes
} from "@/appComponents/Blocks/Modals/SettingsModal/ChartSettings/DataSourceConfiguration/DataSources/DataSourceSetupComposite";

export const UKGProRaasSetupComposite = ({ config, onChange, index, importType, chartConfig }) => {
  const isAppendSource = importType === "append";
  return (
    <DataSourceSetupComposite
      config={config}
      onChange={onChange}
      index={index}
      chartConfig={chartConfig}
      showInputControls
      showConfiguration={isAppendSource}
      showLoadHeaders={isAppendSource}
      importType={importType}
      ATSType={enumATSModes.toggleATS}
    />
  );
};
